<h2 mat-dialog-title class="text-lg">Submit Video</h2>
<mat-dialog-content>
    <form *ngIf="data" [formGroup]="viewModel.form">
        <div class="space-y-md md-sm mt-md">
            <div class="form-group">
                <label>Label Multiple Speakers</label>
                <mat-slide-toggle formControlName="multipleSpeakers" color="primary"></mat-slide-toggle>
            </div>
            <div class="form-group">
                <app-dropdown
                    label="Engine"
                    formControlName="engine"
                    [options]="engines"
                    [(ngModel)]="engine"></app-dropdown>
            </div>
            <div class="form-group">
                <app-dropdown
                    label="Language"
                    formControlName="language"
                    [options]="languages"
                    [(ngModel)]="language"></app-dropdown>
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="flex justify-end ml-auto">
        <button class="btn btn-secondary mr-sm" [mat-dialog-close]="true">Cancel</button>
        <button class="btn btn-primary" (click)="upload()">Upload</button>
    </div>
</mat-dialog-actions>